import React from 'react'
import { checkmarkColorClasses, Container } from '@styles/global/helpers'
import { ICourse } from '@et/types/Courses'
import {
  CenterContent,
  DescriptorItem,
  Descriptors,
  ImageContainer, Lockup,
  SectionOneOuterPadding,
} from '@styles/modules/sections/sectionOne'
import ImgSmall from '@components/imageModules/v2/imgSmall'
import { IGatsbyChildImageSharp, IGatsbyImageDataObject, IGatsbyImgV3ChildImageSharp } from '@et/types/Gatsby'
import GatsbyImgSmall from '@components/imageModules/v3/gatsbyImgSmall'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import CtaButton from '@components/buttons/ctaButton'

interface IProps {
  customCheckMarkColors?: string []
  customBgColor?: string
  gatsbyImg: IGatsbyImageDataObject
  ctaButton?: any
}

function SectionA (props: ICourse & IProps) {
  const { title, classDescriptor, intro, customCheckMarkColors, customBgColor, gatsbyImg, ctaButton } = props

  return (
    <SectionOneOuterPadding customBgColor={customBgColor}>
      <Container>
        <CenterContent>
          <ImageContainer>

            {/*Check after upgrading to migrate V3 until I convert all the courses*/}
            <GatsbyImage alt={title} image={gatsbyImg.gatsbyImageData} loading={GATSBYIMGLOADING.LAZY} />

          </ImageContainer>
          <Lockup>
            <h2>{title}</h2>
            <h3>{classDescriptor}</h3>
          </Lockup>
          <Descriptors>
            {intro.bullets.map((item, index) => {
              return (
                <DescriptorItem
                  key={index}
                  style={customCheckMarkColors ? { color: customCheckMarkColors[index] } : {}}
                  className={customCheckMarkColors ? '' : checkmarkColorClasses[index]}
                >
                  <span>
                    <svg className='checkmark' viewBox='0 0 20 15' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        style={customCheckMarkColors ? { fill: customCheckMarkColors[index] } : {}}
                        d='M16.7893 0L19.1817 2.35363L6.46825 14.8609L0 8.49756L2.40602 6.14724L6.46848 10.1438L16.7893 0Z'/>
                    </svg>

                  </span>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </DescriptorItem>
              )
            })}
          </Descriptors>

          {ctaButton}
        </CenterContent>
      </Container>
    </SectionOneOuterPadding>
  )
}

export default SectionA
